import React from 'react';
import Media from "./Media";
import styles from './Welcomer.module.scss';

const Welcomer = ({ logo, customer }) => {

  if(!customer) {
    return <></>
  }

  return (
    <div className={styles.top}>
      <Media image={logo} />
      <div>
        { customer.name && <span>Hi, {customer.name}!</span>}
        <span>You have <strong>{ customer.points.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") }</strong> points.</span>
      </div>
    </div>
  )
}

export default Welcomer;
